import React from "react";
import { FormCostCenter } from "./FormCostCenter";
import { ICostCenter } from "../models/ICostCenter";

interface Props {
  onClose: () => void;
  costCenter?: Partial<ICostCenter> & Record<string, any>;
  onSubmit?: (values: Record<string, string>) => void;
  stateOptions?: any[];
}

export const ModalCostCenter = ({
  onClose,
  costCenter,
  onSubmit,
  stateOptions,
}: Props) => {
  return (
    <FormCostCenter
      onClose={onClose}
      initialValues={costCenter}
      onSubmit={onSubmit}
      stateOptions={stateOptions}
    />
  );
};
